import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Printer } from 'lucide-react';
import WeightTagListToolbar from '../components/toolbars/WeightTagListToolbar';
import '../index.css';

const WeightTagList = () => {
    const [weightTags, setWeightTags] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchWeightTags();
    }, []);

    const fetchWeightTags = async () => {
        try {
            const response = await axios.get('/api/weightTags');
            setWeightTags(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching weight tags:', error);
            setLoading(false);
        }
    };

    const handlePrint = (id) => {
        navigate(`/weight-tags/${id}/print`);
    };

    const handleRowClick = (e, tag) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(`/weight-tags/edit/${tag.id}`);
    };

    if (loading) {
        return (
            <>
                <WeightTagListToolbar onAdd={() => navigate('/weight-tags/new')} />
                <div className="container mt-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <WeightTagListToolbar onAdd={() => navigate('/weight-tags/new')} />
            
            <div className="container mt-4">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Vineyard</th>
                                        <th>Varietal</th>
                                        <th>Grower</th>
                                        <th>Net Weight</th>
                                        <th>Tons</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {weightTags.map((tag) => (
                                        <tr 
                                            key={tag.id}
                                            onClick={(e) => handleRowClick(e, tag)}
                                            style={{ cursor: 'pointer' }}
                                            className="table-row-hover"
                                        >
                                            <td>{new Date(tag.date).toLocaleDateString()}</td>
                                            <td>{tag.vineyardName}</td>
                                            <td>{tag.varietal}</td>
                                            <td>{tag.growerName}</td>
                                            <td>{!isNaN(tag.totalNet) ? Number(tag.totalNet).toFixed(2) : 'N/A'} lbs</td>
                                            <td>{!isNaN(tag.totalTons) ? Number(tag.totalTons).toFixed(3) : 'N/A'}</td>
                                            <td>
                                                <button
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePrint(tag.id);
                                                    }}
                                                    title="Print Weight Tag"
                                                >
                                                    <Printer size={16} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WeightTagList;